export const environment = {
  production: true,
  backendUrl: 'https://b2b-api.oo.no/',
  requestPriceEmail: 'post@oo.no',
  externalPimUrl: 'https://pim.oo.no/',
  enableWarrantyClaims: true,
  disableStandardGungTitle: true
};
